
import { Navbar } from '../../components/navbar'
import { HeroSection } from '../../sections/hero'
import { AboutMe } from '../../sections/about'
import { Portfolio } from '../../sections/portfolio'
import { Services } from '../../sections/service'
import { Reviews } from '../../sections/reviews'
// import { Pricing } from '../../sections/pricing'
import { ContactSection } from '../../sections/contact'
import { WhyChooseMe } from '../../sections/whychooseus'
import { Footer } from '../../components/footer'
import { WhatsAppButton } from '../../components/WhatsAppButton'
import ChatBot, { ChatBotProvider } from "react-chatbotify";
import ChatbotWidget from '../../components/chatbot'

const HomePage = () => {

    const id = "momin-chatbot"; // give it any custom id

    const flow = {
        start: {
            message: "Hello 👋, I’m Momin Hussain. How can I help you today?",
            path: "end",
        },
        end: {
            message: "Thank you for visiting! – Momin Hussain",
        },
    };

    return (
        <>
            <Navbar />
            <HeroSection />
            <AboutMe />
            <Portfolio />
            <Services />
            <Reviews />
            {/* <Pricing /> */}
            <WhyChooseMe />
            <ContactSection />
            <Footer />
            <ChatbotWidget/>
            <WhatsAppButton />
            {/* <ChatBotProvider>
                <ChatBot id={id} flow={flow} />
            </ChatBotProvider> */}
        </>
    )
}

export default HomePage